import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p>Please reload the app.</p>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

/* PWA: register the runtime-caching service worker (public/sw.js).
 *
 * The path is absolute with an explicit scope rather than PUBLIC_URL-derived:
 * package.json sets "homepage": "." so PUBLIC_URL is the empty string, and a
 * worker registered from a relative path would take the scope of whatever
 * route the user happened to land on first — `/mice` would control `/mice*`
 * and nothing else.
 *
 * Skipped on iOS (Capacitor ships its own bundled assets and has no network
 * shell to cache) and on insecure origins, where registration throws.
 */
if (
  'serviceWorker' in navigator &&
  window.isSecureContext &&
  !Capacitor.isNativePlatform()
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => console.warn('Service worker registration failed:', err));
  });
}
